export default (axios) => ({
    addVideo: (data) => axios.post('/amusement/add-product-to-video', data).then((_) => _.data),
    findVideo: (data) => axios.post('/amusement/find-product-in-video', data).then((_) => _.data),
});
